
export default {
  name: 'AMoney',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Object],
      default: '0',
    },
    noSymbol: {
      type: Boolean,
      default: false,
    },
    noMoney: {
      type: Boolean,
      default: false,
    },
    classSupText: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    symbol: '$',
    money: 'MXN',
  }),
  computed: {
    result() {
      return (this.noSymbol ? '' : this.symbol) + this.value;
    },
  },
};
